import { render, staticRenderFns } from "./ProductNumbersChart.vue?vue&type=template&id=9fb81238"
import script from "./ProductNumbersChart.vue?vue&type=script&lang=js"
export * from "./ProductNumbersChart.vue?vue&type=script&lang=js"
import style0 from "./ProductNumbersChart.vue?vue&type=style&index=0&id=9fb81238&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports